import { useTranslation } from 'next-i18next'

import LockIcon from '~/components/Icons/svgs/LockIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'

export default function AccessExpiredMobileApp(): React.ReactElement {
  const { t } = useTranslation('subscription')
  return (
    <aside className="fixed z-modal-top inset-0 bg-black/70 backdrop-filter backdrop-blur-sm text-white border  overflow-y-auto">
      <section className="min-h-full flex items-center justify-center p-3 sm:p-4">
        <div className="flex flex-col items-center justify-center bg-purple-gdark rounded border border-blue-pastel/25 shadow-lg p-6 max-w-xs w-full text-center">
          <div className="flex justify-center items-center w-14 h-14 bg-purple-pastel/15 rounded-full">
            <SVGIcon icon={LockIcon} pathClassName="text-white" size={24} />
          </div>
          <h2 className="text-m-lg font-black my-4">{t('accessEnded')}</h2>
          <p className="text-sm">
            {t('subscriptionNoLongerActive')}
            <br />
            <br />
            {t('visitHomeToReactivate')}
          </p>
        </div>
      </section>
    </aside>
  )
}
